import { BalanceResponse, BalanceResponseApi } from "./response";
import {BalanceRequestParams} from './request'

export namespace Balance {

  export type Response = BalanceResponse;
  export const Response = BalanceResponse;
  
  export type ResponseApi = BalanceResponseApi
  export const ResponseApi = BalanceResponseApi

  export const Params = BalanceRequestParams
  export type Params = BalanceRequestParams
}